import Vue from 'vue';
import Vuex from 'vuex';
import filters from './modules/filters';
import products from './modules/products';
import collection from './modules/collection'
import * as types from "./types";


Vue.use(Vuex);

export const store = new Vuex.Store({


    state: {
        config: {
            hostname: '',
        },
        result: {
            products: [],
            bestsellers: [],
            nbProductsDisplay: 20,
        }
    },
    getters: {
        /**
         *
         * @param state
         * @returns {*}
         */
        [types.GET_HOSTNAME]: state => {
            return state.config.hostname;
        },
        /**
         *
         * @param state
         * @returns {Array|*|{mutations, state, getters, actions}|default.computed.products|state.products|{}}
         */
        [types.GET_PRODUCTS_RESULT]: state => {
            return state.result.products;
        },
        /**
         *
         * @param state
         * @returns {Array}
         */
        [types.GET_BESTSELLERS_RESULT]: state => {
            return state.result.bestsellers;
        },
        /**
         *
         * @param state
         * @returns {*|number}
         */
        [types.GET_NB_PRODUCTS_DISPLAY]: state => {
            return state.result.nbProductsDisplay;
        },
    },
    actions: {
        /**
         *
         * @param commit
         * @param payload
         */
        [types.SET_HOSTNAME]: ({commit}, payload) => {
            commit(types.MUTATE_SET_HOSTNAME, payload);
        },
        /**
         *
         * @param state
         * @param commit
         * @param product
         */
        [types.ADD_PRODUCT_RESULT]: ({state, commit}, product) => {
            commit(types.MUTATE_ADD_PRODUCT_RESULT, product);
        },
        /**
         *
         * @param state
         * @param commit
         * @param product
         */
        [types.ADD_BESTSELLER_RESULT]: ({state, commit}, product) => {
            commit(types.MUTATE_ADD_BESTSELLER_RESULT, product);
        },
        /**
         *
         * @param state
         * @param commit
         */
        [types.UPDATE_PRODUCT_RESULT]: ({state, commit}) => {
            const filters = state.filters.checked;
            commit(types.MUTATE_UPDATE_PRODUCT_RESULT, {filters, products: state.products.products});
        },
        /**
         *
         * @param state
         * @param commit
         * @param nbProductsDisplay
         */
        [types.UPDATE_NB_PRODUCTS_DISPLAY]: ({state, commit}, nbProductsDisplay) => {
            commit(types.MUTATE_UPDATE_NB_PRODUCTS_DISPLAY, {nbProductsDisplay});
        },

    },
    mutations: {
        /**
         *
         * @param state
         * @param hostname
         */
        [types.MUTATE_SET_HOSTNAME]: (state, hostname) => {
            state.config.hostname = hostname;
        },
        /**
         *
         * @param state
         * @param product
         */
        [types.MUTATE_ADD_PRODUCT_RESULT]: (state, product) => {
            state.result.products.push(product);
        },
        /**
         *
         * @param state
         * @param product
         */
        [types.MUTATE_ADD_BESTSELLER_RESULT]: (state, product) => {
            state.result.bestsellers.push(product);
        },
        /**
         *
         * @param state
         * @param filters
         * @param products
         */
        [types.MUTATE_UPDATE_PRODUCT_RESULT]: (state, {filters, products}) => {
            state.result.products = products.filter(item => {
                if (filters.feature.length === 0 && filters.attribute.length === 0) {
                    return true;
                }
                let result = false;

                filters.feature.forEach(feature => {
                    let {products} = feature;
                    if (products && products.length > 0) {
                        result |= products.find(idProduct => idProduct === item.id);
                    }
                });

                if (result) {
                    return result;
                }
                filters.attribute.forEach(attribute => {
                    let {products} = attribute;
                    if (products && products.length > 0) {
                        result |= products.find(idProduct => idProduct === item.id);
                    }
                });

                return result;
            });
        },
        /**
         *
         * @param state
         * @param nbProductsDisplay
         */
        [types.MUTATE_UPDATE_NB_PRODUCTS_DISPLAY]: (state, {nbProductsDisplay}) => {
            state.result.nbProductsDisplay = nbProductsDisplay;
        }
    },
    modules: {
        collection,
        products,
        filters,
    }
});


// WEBPACK FOOTER //
// ./src/store/store.js